export const useDifficultyDistributionModelInfo = () => {
  const fiveDayColumns = [
    {
      key: 'monday',
      title: 'Пн',
      dataIndex: ['monday'],
    },
    {
      key: 'tuesday',
      title: 'Вт',
      dataIndex: ['tuesday'],
    },
    {
      key: 'wednesday',
      title: 'Ср',
      dataIndex: ['wednesday'],
    },
    {
      key: 'thursday',
      title: 'Чт',
      dataIndex: ['thursday'],
    },
    {
      key: 'friday',
      title: 'Пт',
      dataIndex: ['friday'],
    },
  ];
  const sixDayColumns = [
    ...fiveDayColumns,
    {
      key: 'saturday',
      title: 'Сб',
      dataIndex: ['saturday'],
    },
  ];

  const fiveDayHillDataSource = [
    {
      id: 1,
      monday: '18 и менее',
      tuesday: '19 - 20',
      wednesday: '21 - 24',
      thursday: '19 - 20',
      friday: '18 и менее',
    },
  ];

  const fiveDaySnakeDataSource = [
    {
      id: 1,
      monday: '17 и менее',
      tuesday: '21 - 24',
      wednesday: '17 - 18',
      thursday: '21 - 24',
      friday: '17 и менее',
    },
  ];

  const sixDayHillDataSource = [
    {
      id: 1,
      monday: '15 и менее',
      tuesday: '17 - 18',
      wednesday: '19 - 20',
      thursday: '19 - 20',
      friday: '16 - 17',
      saturday: '14 и менее',
    },
  ];

  const sixDaySnakeDataSource = [
    {
      id: 1,
      monday: '15 и менее',
      tuesday: '17 - 18',
      wednesday: '20 - 21',
      thursday: '16 - 17',
      friday: '18 - 19',
      saturday: '14 и менее',
    },
  ];

  return {
    state: {
      fiveDayColumns,
      sixDayColumns,
      fiveDayHillDataSource,
      fiveDaySnakeDataSource,
      sixDayHillDataSource,
      sixDaySnakeDataSource,
    },
  };
};
